export default __webpack_public_path__ + "static/media/primaVisita.77605dba.png";